"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTestId = void 0;
const react_1 = require("react");
const context_1 = require("./context");
const useTestId = () => {
    return (0, react_1.useContext)(context_1.TestIdContext);
};
exports.useTestId = useTestId;
//# sourceMappingURL=hook.js.map